import script from "./GastroView.vue?vue&type=script&setup=true&lang=js"
export * from "./GastroView.vue?vue&type=script&setup=true&lang=js"

import "./GastroView.vue?vue&type=style&index=0&id=42dedf24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42dedf24"]])

export default __exports__